import axios from 'api/axios';

export async function getOnlineUsers({ roles, page, limit, from, to }) {
  const queryParams = new URLSearchParams('');
  queryParams.set('page', page);
  queryParams.set('limit', limit);
  roles.map((role) => {
    queryParams.append('role', role);
  });
  queryParams.set('from', from);
  queryParams.set('to', to);
  const { data } = await axios.get(
    `api/v1/admin/reports/listAppUsers?${queryParams.toString()}`
  );
  return data;
}

export async function getSpeceficUser({ userId, page, limit, from, to }) {
  const queryParams = new URLSearchParams('');
  queryParams.set('page', page);
  queryParams.set('limit', limit);
  // roles.map((role) => {
  //   queryParams.append('role', role);
  // });
  queryParams.set('from', from);
  queryParams.set('to', to);
  // const { data } = await axios.get(
  //   `/api/v1/admin/reports/listAppUsers/user/${userId}/?page=1&limit=10&from=2023-04-10&to=2023-04-10`
  // );
  const { data } = await axios.get(
    `/api/v1/admin/reports/listAppUsers/user/${userId}/?${queryParams.toString()}`
  );
  // ?${queryParams.toString()}
  return data;
}
